/* eslint-disable max-len */
import { useContext, useCallback } from "react";
import DashboardTextCard from "../Content/DashboardTextCard";
import DashboardProgressCard from "../Content/DashboardProgressCard";
import AccordionPanel from "../Content/AccordionPanel";

// import { CalculationLoader } from "../Content/CalculationLoader";

import IconInfo from "../../Images/static/media/svg/info.svg";

// import buildingRating1 from "../../Images/building-rating/building-rating-1.svg";
// import { ReactComponent as BuildingRating1 } from "../../Images/building-rating/building-rating-1.svg";
// import costForecast2 from "../../Images/cost-forecast/cost-forecast-2.svg";

// import { ReactComponent as CostForecast2 } from "../../Images/cost-forecast/cost-forecast-2.svg";

import CalculatorContext from "../../Context/CalculatorContext";

import {
  calculateEmission,
  getBuildingRatingChart,
  calculateTenYearsCost,
} from "../../utils/Calculator";

function SimulationPage() {
  const {
    forecastStartYear,
    energySource,
    fuelConsumptionAmount,
    fuelConsumptionType,
    customFernwarmeFactor,
    customEmission,
    livingSpace,
    isCommercialProperty,
    isEnergyImprovementPossible,
    isSupplyImprovementPossible,
    isSimulationEnabled,
    setIsSimulationEnabled,
    co2Prices,
  } = useContext(CalculatorContext);

  const emission = calculateEmission(
    energySource,
    fuelConsumptionType,
    fuelConsumptionAmount,
    customFernwarmeFactor,
    customEmission,
  );

  const tenYearsCost = calculateTenYearsCost(
    forecastStartYear,
    isSimulationEnabled ? emission.defaultEmission * (1 - 0.15) : emission.defaultEmission,
    isSimulationEnabled ? emission.totalEmission * (1 - 0.15) : emission.totalEmission,
    +isCommercialProperty,
    +isEnergyImprovementPossible,
    +isSupplyImprovementPossible,
    livingSpace,
    co2Prices,
  );

  const tenYearsCostWithoutReducing = calculateTenYearsCost(
    forecastStartYear,
    emission.defaultEmission,
    emission.totalEmission,
    +isCommercialProperty,
    +isEnergyImprovementPossible,
    +isSupplyImprovementPossible,
    livingSpace,
    co2Prices,
  );

  const buildingRatingChart = getBuildingRatingChart(
    isSimulationEnabled ? emission.defaultEmission * (1 - 0.15) : emission.defaultEmission,
    isSimulationEnabled ? emission.totalEmission * (1 - 0.15) : emission.totalEmission,
    +isCommercialProperty,
    +isEnergyImprovementPossible,
    +isSupplyImprovementPossible,
    livingSpace,
  );

  const renderTenYearsCostForecastTable = useCallback(
    (forecast, forecastWithoutReducing) => {
      if (isSimulationEnabled) {
        return forecast.map((forecastObj, index) => {
          const landLordBasis = parseFloat(forecastWithoutReducing[index].landlordAmount);

          const renterBasis = parseFloat(forecastWithoutReducing[index].renterAmount);

          return (
            <tr key={forecastObj.year}>
              <td>{forecastObj.year}</td>
              <td className="w-50">
                <div className="card card-tertiary card-progress">
                  <div className="card-progress-value">{forecastObj.landlordAmountFormatted}</div>
                  <div className="card-progress-bar bg-secondary" style={{ width: "50%" }}>
                    <div className="card-progress-value">
                      <b>
                        {Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(
                          forecastObj.landlordAmount - landLordBasis,
                        )}{" "}
                      </b>
                    </div>
                  </div>
                </div>
              </td>
              <td className="w-50">
                <div className="card card-primary card-progress">
                  <div className="card-progress-value">{forecastObj.renterAmountFormatted}</div>
                  <div className="card-progress-bar bg-secondary" style={{ width: "50%" }}>
                    <div className="card-progress-value">
                      <b>
                        {Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(
                          forecastObj.renterAmount - renterBasis,
                        )}{" "}
                      </b>
                    </div>
                  </div>
                </div>
              </td>
              <td className="text-end">
                <b>{forecastObj.totalAmountFormatted}</b>
              </td>
            </tr>
          );
        });
      }

      return forecast.map((forecastObj) => {
        return (
          <tr key={forecastObj.year}>
            <td>{forecastObj.year}</td>
            <td className="w-50">
              <div className="card card-tertiary card-progress">
                <div className="card-progress-value">{forecastObj.landlordAmountFormatted}</div>
              </div>
            </td>
            <td className="w-50">
              <div className="card card-primary card-progress">
                <div className="card-progress-value">{forecastObj.renterAmountFormatted}</div>
              </div>
            </td>
            <td className="text-end">
              <b>{forecastObj.totalAmountFormatted}</b>
            </td>
          </tr>
        );
      });
    },
    [isSimulationEnabled],
  );

  const renderTenYearsCostForecastBlock = useCallback(
    (forecast, forecastWithoutReducing) => {
      if (isSimulationEnabled) {
        return forecast.map((forecastObj, index) => {
          const landLordBasis = parseFloat(forecastWithoutReducing[index].landlordAmount);

          const renterBasis = parseFloat(forecastWithoutReducing[index].renterAmount);

          return (
            <div className="block-cost-forecast-item" key={forecastObj.year}>
              <div className="block-cost-forecast-year">
                <strong>{forecastObj.year}</strong>
              </div>

              <div className="card card-tertiary card-progress">
                {/* <div className="card-progress-name">Vermieter</div> */}
                <div className="card-progress-value">{forecastObj.landlordAmountFormatted}</div>
                <div className="card-progress-bar bg-secondary" style={{ width: "50%" }}>
                  <div className="card-progress-value">
                    <b>
                      {Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(
                        forecastObj.landlordAmount - landLordBasis,
                      )}{" "}
                    </b>
                  </div>
                </div>
              </div>

              <div className="card card-primary card-progress">
                {/* <div className="card-progress-name">Mieter</div> */}
                <div className="card-progress-value">{forecastObj.renterAmountFormatted}</div>
                <div className="card-progress-bar bg-secondary" style={{ width: "50%" }}>
                  <div className="card-progress-value">
                    <b>
                      {Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(
                        forecastObj.renterAmount - renterBasis,
                      )}{" "}
                    </b>
                  </div>
                </div>
              </div>

              <div className="card card-transparent card-progress">
                <div className="card-progress-name">
                  <strong>Kosten gesamt</strong>
                </div>
                <div className="card-progress-value text-body">
                  <strong>{forecastObj.totalAmountFormatted}</strong>
                </div>
              </div>
            </div>
          );
        });
      }

      return forecast.map((forecastObj) => {
        return (
          <div className="block-cost-forecast-item" key={forecastObj.year}>
            <div className="block-cost-forecast-year">
              <strong>{forecastObj.year}</strong>
            </div>

            <div className="card card-tertiary card-progress">
              <div className="card-progress-name">Vermieter</div>
              <div className="card-progress-value">{forecastObj.landlordAmountFormatted}</div>
            </div>

            <div className="card card-primary card-progress">
              <div className="card-progress-name">Bewohner</div>
              <div className="card-progress-value">{forecastObj.renterAmountFormatted}</div>
            </div>

            <div className="card card-transparent card-progress">
              <div className="card-progress-name">
                <strong>Kosten gesamt</strong>
              </div>
              <div className="card-progress-value text-body">
                <strong>{forecastObj.totalAmountFormatted}</strong>
              </div>
            </div>
          </div>
        );
      });
    },
    [isSimulationEnabled],
  );

  return (
    <div className="tx-kalo form-steps-abwizard">
      {/* <div className="frame frame-size-default form-steps-abwizard form-steps-abwizard-transparent frame-full frame-background-tertiary">
        <div className="frame-group-container">
          <div className="frame-container frame-container-default">
            <CalculationLoader />
          </div>
        </div>
      </div> */}

      <div className="frame frame-size-default frame-indent-10 frame-type-text layout-stage frame-background-tertiary frame-has-backgroundimage frame-has-backgroundimage-svg frame-pattern-none frame-space-before-none frame-space-after-medium">
        <div className="frame-group-container">
          <div className="frame-group-inner">
            <div className="frame-backgroundimage-container">
              <div id="frame-backgroundimage-862" className="frame-backgroundimage">
                <style>
                  {` 
                    
                    #frame-backgroundimage-862 { 
                      background-image: url('https://heizkosten.kalo.de/fileadmin/media/patterns/kalo-pattern_green-3.svg'); 
                    } 

                    @media (min-width: 756px) {
                      #frame-backgroundimage-862 { 
                        background-image: url('https://heizkosten.kalo.de/fileadmin/media/patterns/kalo-pattern_green-3.svg'); 
                      } 
                    } 
                    
                    @media (min-width: 992px) { 
                      #frame-backgroundimage-862 { 
                        background-image: url('https://heizkosten.kalo.de/fileadmin/media/patterns/kalo-pattern_green-3.svg'); 
                      } 
                    } 
                    
                    @media (min-width: 1400px) { 
                      #frame-backgroundimage-862 { background-image: url('https://heizkosten.kalo.de/fileadmin/media/patterns/kalo-pattern_green-3.svg'); 
                    } 
                  } 
                  
                  `}
                </style>
              </div>
            </div>
            <div className="frame-container frame-container-default">
              <div className="frame-inner frame-inner-space-before-medium frame-inner-space-after-medium">
                <header className="frame-header frame-header-h3 frame-header-space-small">
                  <h3 className="element-header text-center">
                    <span>
                      <span className="text-primary">Energie sparen Lorem ipsum </span>
                      <br /> mit smarten Thermostaten
                    </span>
                  </h3>
                </header>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="frame frame-size-default frame-indent-6 frame-type-text layout-0 frame-background-none frame-no-backgroundimage frame-pattern-none frame-space-before-none frame-space-after-medium">
        <div className="frame-group-container">
          <div className="frame-group-inner">
            <div className="frame-container frame-container-default">
              <div className="frame-inner frame-inner-space-before-none frame-inner-space-after-none">
                <p className="text-large">
                  Durch einfache Lösungen können Sie die Energiebilanz Ihrer Liegenschaft verbessern
                  und <strong>nachhaltig Kosten einsparen</strong>. So kann beispielsweise ein
                  Aufrüsten ihrer Heizung mit smarten Thermostaten die CO<sub>2</sub>-Emission ihrer
                  gesamten Liegenschaft um bis zu <strong>15 % reduzieren</strong>. Eine optimale
                  Reduktion, können Sie in unserer Simulation direkt austesten:
                </p>

                <p className="text-large text-center">
                  <button
                    type="submit"
                    className="btn btn-default"
                    disabled={isSimulationEnabled}
                    onClick={(e) => {
                      e.preventDefault();

                      setIsSimulationEnabled(!isSimulationEnabled);
                    }}
                  >
                    Einsparung simulieren
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="frame frame-size-default frame-indent-10 frame-type-text layout-0 frame-background-none frame-no-backgroundimage frame-pattern-none frame-space-before-none frame-space-after-extra-small">
        <div className="frame-group-container">
          <div className="frame-container frame-container-default">
            <div className="frame-inner frame-inner-space-before-extra-small frame-inner-space-after-none">
              <div className="row">
                <div className="col-12">
                  <pre>
                    <code>
                      {JSON.stringify(
                        {
                          energySource,
                          fuelConsumptionAmount,
                          fuelConsumptionType,
                          livingSpace,
                          isCommercialProperty,
                          isEnergyImprovementPossible,
                          isSupplyImprovementPossible,
                          isSimulationEnabled,
                        },
                        null,
                        4,
                      )}
                    </code>
                  </pre>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="frame frame-size-default frame-indent-10 frame-type-text layout-0 frame-background-none frame-no-backgroundimage frame-pattern-none frame-space-before-none frame-space-after-extra-small">
        <div className="frame-group-container">
          <div className="frame-container frame-container-default">
            <div className="frame-inner frame-inner-space-before-none frame-inner-space-after-none">
              <div className="row">
                <div className="col-12">
                  <AccordionPanel
                    id={1}
                    isStatic
                    headlineLeft={
                      <div>
                        <div className="d-flex align-items-center">
                          <span>
                            CO<sub>2</sub>-Gesamtkosten auf 10 Jahre
                            <span className="mx-3">
                              <a
                                href="#"
                                data-bs-target="#floatinTrigerSocial"
                                tabIndex="0"
                                data-bs-toggle="modal"
                                className="accordion-button-additional-modal-trigger"
                                aria-label="Open total costs information  modal"
                              >
                                <img
                                  className="accordion-button-additional-modal-icon"
                                  src={IconInfo}
                                  alt=""
                                />
                              </a>
                            </span>
                          </span>
                        </div>
                        <div className="subline mt-3 mb-2 mb-md-0">
                          {`(${forecastStartYear} - ${Number(forecastStartYear) + 9})`}
                        </div>
                      </div>
                    }
                    headlineRight={
                      <div className="accordion-button-additional-info-text">
                        {tenYearsCost.totalAmountFormatted}
                        {isSimulationEnabled ? (
                          <div className="badge bg-secondary">
                            Ersparnis von{" "}
                            {Intl.NumberFormat("de-DE", {
                              style: "currency",
                              currency: "EUR",
                            }).format(
                              tenYearsCostWithoutReducing.totalAmount - tenYearsCost.totalAmount,
                            )}
                          </div>
                        ) : null}
                      </div>
                    }
                  >
                    <div className="row row-cols-1 row-cols-md-2 gy-3 gx-5">
                      <div className="col">
                        <DashboardTextCard
                          headlineLeft="Kosten Vermieter"
                          headlineRight={`${tenYearsCost.landlordAmountFormatted}`}
                          midlineLeft={isSimulationEnabled ? "Ersparnis" : null}
                          midlineRight={
                            isSimulationEnabled
                              ? Intl.NumberFormat("de-DE", {
                                  style: "currency",
                                  currency: "EUR",
                                }).format(
                                  tenYearsCost.landlordAmount -
                                    tenYearsCostWithoutReducing.landlordAmount,
                                )
                              : null
                          }
                          prelineLeft="CO<sub>2</sub>-Kostenanteil"
                          prelineRight={`${tenYearsCost.landlordPercentage} %`}
                        />
                        {/* <div className="card card-tertiary card-dashboard-text">
                          <div className="card-body">
                            <div className="card-content">
                              <div className="card-headline-wrapper">
                                <h5
                                  className="card-headline text-primary"
                                  dangerouslySetInnerHTML={{ __html: headlineLeft }}
                                />
                                <h5
                                  className="card-headline text-primary"
                                  dangerouslySetInnerHTML={{ __html: headlineRight }}
                                />
                              </div>
                              <div className="card-preline-wrapper">
                                <div
                                  className="card-preline"
                                  dangerouslySetInnerHTML={{ __html: prelineLeft }}
                                />
                                <div
                                  className="card-preline"
                                  dangerouslySetInnerHTML={{ __html: prelineRight }}
                                />
                              </div>
                            </div>
                          </div>
                        </div> */}
                      </div>
                      <div className="col">
                        <DashboardTextCard
                          type="primary"
                          headlineLeft="Kosten Bewohner"
                          headlineRight={`${tenYearsCost.renterAmountFormatted}`}
                          midlineLeft={isSimulationEnabled ? "Ersparnis" : null}
                          midlineRight={
                            isSimulationEnabled
                              ? Intl.NumberFormat("de-DE", {
                                  style: "currency",
                                  currency: "EUR",
                                }).format(
                                  tenYearsCost.renterAmount -
                                    tenYearsCostWithoutReducing.renterAmount,
                                )
                              : null
                          }
                          prelineLeft="CO<sub>2</sub>-Kostenanteil"
                          prelineRight={`${tenYearsCost.renterPercentage} %`}
                        />
                        {/* <div className="card card-primary card-dashboard-text">
                          <div className="card-body">
                            <div className="card-content">
                              <div className="card-headline-wrapper">
                                <h5
                                  className="card-headline text-secondary"
                                  dangerouslySetInnerHTML={{ __html: headlineLeft }}
                                />
                                <h5
                                  className="card-headline text-secondary"
                                  dangerouslySetInnerHTML={{ __html: headlineRight }}
                                />
                              </div>
                              <div className="card-preline-wrapper">
                                <div
                                  className="card-preline"
                                  dangerouslySetInnerHTML={{ __html: prelineLeft }}
                                />
                                <div
                                  className="card-preline"
                                  dangerouslySetInnerHTML={{ __html: prelineRight }}
                                />
                              </div>
                            </div>
                          </div>
                        </div> */}
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-12">
                        <DashboardProgressCard
                          leftValue={`${tenYearsCost.landlordPercentage}%`}
                          rightValue={`${tenYearsCost.renterPercentage}%`}
                          progressAmount={`${tenYearsCost.landlordPercentage}%`}
                        />
                        {/* <div className="card card-progress">
                          <div className="card-progress-bar" style={{ width: "40%" }} />
                          <div className="card-progress-value">40%</div>
                          <div className="card-progress-value">60%</div>
                        </div> */}
                      </div>
                    </div>
                  </AccordionPanel>
                  {/* <div className="accordion accordion-flush accordion-panel" id="accordion-panel-1">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="accordion-panel-headline-1">
                        <div className="accordion-button-wrapper">
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#accordion-panel-collapse-1"
                            aria-expanded="true"
                            aria-controls="accordion-panel-collapse-1"
                          >
                            <div className="accordion-button-content">
                              <span>Accordion Item #1</span>
                              <div className="accordion-button-additional-info">15.266,89 €</div>
                            </div>
                          </button>
                        </div>
                      </h2>
                      <div
                        id="accordion-panel-collapse-1"
                        className="accordion-collapse collapse show"
                        aria-labelledby="accordion-panel-headline-1"
                        data-bs-parent="#accordion-panel-1"
                      >
                        <div className="accordion-body">
                          Placeholder content for this accordion, which is intended to demonstrate
                          the <code>.accordion-flush</code> class. This is the first items accordion
                          body.
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="frame frame-size-default frame-indent-10 frame-type-text layout-0 frame-background-none frame-no-backgroundimage frame-pattern-none frame-space-before-none frame-space-after-extra-small">
        <div className="frame-group-container">
          <div className="frame-container frame-container-default">
            <div className="frame-inner frame-inner-space-before-none frame-inner-space-after-none">
              <div className="row">
                <div className="col-12">
                  <div className="d-flex align-items-center justify-content-center">
                    <a
                      href="#"
                      className="btn btn-icon btn-icon-secondary"
                      onClick={(e) => {
                        e.preventDefault();

                        setIsSimulationEnabled(!isSimulationEnabled);
                      }}
                      aria-label="toggle simulation"
                    >
                      <i className="icon-line-arrow-right" />
                    </a>
                    <h5 className="m-0">
                      Reduktion Ihrer CO<sub>2</sub>–Emission um 15 %
                    </h5>
                    <div className="form-check form-switch m-0 ps-0">
                      <input
                        className="form-check-input ms-5"
                        type="checkbox"
                        value="1"
                        checked={isSimulationEnabled}
                        onChange={(e) => {
                          setIsSimulationEnabled(e.target.checked);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isCommercialProperty === "0" &&
        isEnergyImprovementPossible === "1" &&
        isSupplyImprovementPossible === "1" && (
          <div className="frame frame-size-default frame-indent-10 frame-type-text layout-0 frame-background-none frame-no-backgroundimage frame-pattern-none frame-space-before-none frame-space-after-extra-small">
            <div className="frame-group-container">
              <div className="frame-container frame-container-default">
                <div className="frame-inner frame-inner-space-before-none frame-inner-space-after-none">
                  <div className="row">
                    <div className="col-12">
                      <AccordionPanel
                        id={2}
                        headlineLeft={
                          <span>
                            CO<sub>2</sub>-Einstufung Ihres Gebäudes
                          </span>
                        }
                        headlineRight={
                          <div className="accordion-button-additional-info-legend">
                            <div className="accordion-button-additional-info-legend-item">
                              <div className="accordion-button-additional-info-legend-color bg-tertiary" />
                              <small className="accordion-button-additional-info-legend-tooltip ">
                                Vermieter
                              </small>
                            </div>
                            <div className="accordion-button-additional-info-legend-item">
                              <div className="accordion-button-additional-info-legend-color bg-primary" />
                              <small className="accordion-button-additional-info-legend-tooltip ">
                                Bewohner
                              </small>
                            </div>
                          </div>
                        }
                      >
                        <div className="overflow-auto">
                          {/* <img src={buildingRating1} alt="" width={982} /> */}
                          {/* <BuildingRating1 width={982} /> */}

                          <div
                            dangerouslySetInnerHTML={{
                              __html: buildingRatingChart,
                            }}
                          />

                          <div
                            style={{ width: 982 }}
                            className="d-flex justify-content-between text-tertiary"
                          >
                            <span>Emissonsarme Gebäude</span>
                            <span>Emissionsreiche Gebäude</span>
                          </div>
                        </div>
                      </AccordionPanel>
                      {/* <div className="accordion accordion-flush accordion-panel" id="accordion-panel-2">
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="accordion-panel-headline-2">
                          <div className="accordion-button-wrapper">
                            <button
                              className="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#accordion-panel-collapse-2"
                              aria-expanded="true"
                              aria-controls="accordion-panel-collapse-2"
                            >
                              <div className="accordion-button-content">
                                <span>Accordion Item #2</span>
                                <div className="accordion-button-additional-info">15.266,89 €</div>
                              </div>
                            </button>
                          </div>
                        </h2>
                        <div
                          id="accordion-panel-collapse-2"
                          className="accordion-collapse collapse show"
                          aria-labelledby="accordion-panel-headline-2"
                          data-bs-parent="#accordion-panel-2"
                        >
                          <div className="accordion-body">
                            Placeholder content for this accordion, which is intended to demonstrate
                            the <code>.accordion-flush</code> class. This is the first items accordion
                            body.
                          </div>
                        </div>
                      </div>
                    </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      <div className="frame frame-size-default frame-indent-10 frame-type-text layout-0 frame-background-none frame-no-backgroundimage frame-pattern-none frame-space-before-none frame-space-after-medium">
        <div className="frame-group-container">
          <div className="frame-container frame-container-default">
            <div className="frame-inner frame-inner-space-before-none frame-inner-space-after-none">
              <div className="row">
                <div className="col-12">
                  <AccordionPanel
                    id={3}
                    isStatic
                    headlineLeft={
                      <div>
                        <div className="d-flex align-items-center">
                          <span>
                            CO<sub>2</sub>-Kostenprognose für 10 Jahre
                            <span className="mx-3">
                              <a
                                href="#"
                                data-bs-target="#floatinTrigerContact"
                                tabIndex="0"
                                data-bs-toggle="modal"
                                className="accordion-button-additional-modal-trigger"
                                aria-label="Open cost forecast information modal"
                              >
                                <img
                                  className="accordion-button-additional-modal-icon"
                                  src={IconInfo}
                                  alt=""
                                />
                              </a>
                            </span>
                          </span>
                        </div>

                        <div className="subline mt-3 mb-2 mb-md-0">
                          {`(${forecastStartYear} - ${Number(forecastStartYear) + 9})`}
                        </div>
                      </div>
                    }
                    headlineRight={
                      <div className="accordion-button-additional-info-legend">
                        <div className="accordion-button-additional-info-legend-item">
                          <div className="accordion-button-additional-info-legend-color bg-tertiary" />
                          <small className="accordion-button-additional-info-legend-tooltip ">
                            Vermieter
                          </small>
                        </div>
                        <div className="accordion-button-additional-info-legend-item">
                          <div className="accordion-button-additional-info-legend-color bg-primary" />
                          <small className="accordion-button-additional-info-legend-tooltip ">
                            Bewohner
                          </small>
                        </div>
                      </div>
                    }
                  >
                    <div className="overflow-auto d-none d-lg-block">
                      {/* <img src={costForecast2} alt="" width={982} /> */}
                      <div className="table-responsive">
                        <table className="table table-striped table-cost-forecast">
                          <thead>
                            <tr>
                              <th>Jahr</th>
                              <th>Vermieter</th>
                              <th>Bewohner</th>
                              <th>Kosten gesamt</th>
                            </tr>
                          </thead>
                          <tbody>
                            {renderTenYearsCostForecastTable(
                              tenYearsCost.forecast,
                              tenYearsCostWithoutReducing.forecast,
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="d-block d-lg-none">
                      <div className="block-cost-forecast">
                        {renderTenYearsCostForecastBlock(
                          tenYearsCost.forecast,
                          tenYearsCostWithoutReducing.forecast,
                        )}
                      </div>
                    </div>
                  </AccordionPanel>
                  {/* <div className="accordion accordion-flush accordion-panel" id="accordion-panel-3">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="accordion-panel-headline-3">
                        <div className="accordion-button-wrapper">
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#accordion-panel-collapse-3"
                            aria-expanded="true"
                            aria-controls="accordion-panel-collapse-3"
                          >
                            <div className="accordion-button-content">
                              <span>Accordion Item #3</span>
                              <div className="accordion-button-additional-info-text">
                                15.266,89 €
                              </div>
                            </div>
                          </button>
                        </div>
                      </h2>
                      <div
                        id="accordion-panel-collapse-3"
                        className="accordion-collapse collapse show"
                        aria-labelledby="accordion-panel-headline-3"
                        data-bs-parent="#accordion-panel-3"
                      >
                        <div className="accordion-body">
                          Placeholder content for this accordion, which is intended to demonstrate
                          the <code>.accordion-flush</code> class. This is the first items accordion
                          body.
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SimulationPage;
